import React, { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import AdminLayout from '../pages/admin/components/AdminLayout';
import ProtectedRoute from '../pages/admin/components/ProtectedRoute';

const Home = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const BayiGiris = lazy(() => import('../pages/bayi-giris/page'));
const BayilikBasvuru = lazy(() => import('../pages/bayilik-basvuru/page'));
const Belgelerimiz = lazy(() => import('../pages/belgelerimiz/page'));
const Koleksiyonlar = lazy(() => import('../pages/koleksiyonlar/page'));

// Kurumsal Pages
const Tarihce = lazy(() => import('../pages/kurumsal/tarihce/page'));
const VizyonMisyon = lazy(() => import('../pages/kurumsal/vizyon-misyon/page'));
const Bolgelerimiz = lazy(() => import('../pages/kurumsal/bolgelerimiz/page'));
const Sertifikalarimiz = lazy(() => import('../pages/kurumsal/sertifikalarimiz/page'));
const EKatalog = lazy(() => import('../pages/kurumsal/e-katalog/page'));
const UretimSureci = lazy(() => import('../pages/kurumsal/uretim-sureci/page'));
const ToptanHaliUretimi = lazy(() => import('../pages/kurumsal/toptan-hali-uretimi/page'));
const GaziantepCarpet = lazy(() => import('../pages/kurumsal/gaziantep-carpet/page'));

// Other Pages
const Satis = lazy(() => import('../pages/satis/page'));
const Iletisim = lazy(() => import('../pages/iletisim/page'));
const InsanKaynaklari = lazy(() => import('../pages/insan-kaynaklari/page'));
const Blog = lazy(() => import('../pages/blog/page'));

// Admin Pages
const AdminLogin = lazy(() => import('../pages/admin/login/page'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));
const AdminSliders = lazy(() => import('../pages/admin/sliders/page'));
const AdminProducts = lazy(() => import('../pages/admin/products/page'));
const AdminContact = lazy(() => import('../pages/admin/contact/page'));
const AdminPages = lazy(() => import('../pages/admin/pages/page'));
const AdminBannersPage = lazy(() => import('../pages/admin/banners/page'));
const AdminCatalogPage = lazy(() => import('../pages/admin/catalog/page'));
const AdminGalleryPage = lazy(() => import('../pages/admin/gallery/page'));
const AdminBlogPage = lazy(() => import('../pages/admin/blog/page'));
const AdminMenuSettingsPage = lazy(() => import('../pages/admin/menu-settings/page'));
const AdminLogoSettingsPage = lazy(() => import('../pages/admin/logo-settings/page'));

const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/bayi-giris', element: <BayiGiris /> },
  { path: '/bayilik-basvuru', element: <BayilikBasvuru /> },
  { path: '/belgelerimiz', element: <Belgelerimiz /> },
  { path: '/koleksiyonlar', element: <Koleksiyonlar /> },
  { path: '/kurumsal/tarihce', element: <Tarihce /> },
  { path: '/kurumsal/vizyon-misyon', element: <VizyonMisyon /> },
  { path: '/kurumsal/bolgelerimiz', element: <Bolgelerimiz /> },
  { path: '/kurumsal/sertifikalarimiz', element: <Sertifikalarimiz /> },
  { path: '/kurumsal/e-katalog', element: <EKatalog /> },
  { path: '/kurumsal/uretim-sureci', element: <UretimSureci /> },
  { path: '/kurumsal/toptan-hali-uretimi', element: <ToptanHaliUretimi /> },
  { path: '/kurumsal/gaziantep-carpet', element: <GaziantepCarpet /> },
  { path: '/satis', element: <Satis /> },
  { path: '/iletisim', element: <Iletisim /> },
  { path: '/insan-kaynaklari', element: <InsanKaynaklari /> },
  { path: '/blog', element: <Blog /> },
  {
    path: '/admin',
    element: <Navigate to="/admin/dashboard" replace />,
  },
  {
    path: '/admin/login',
    element: <AdminLogin />,
  },
  {
    path: '/admin',
    element: (
      <ProtectedRoute>
        <AdminLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: 'dashboard',
        element: <AdminDashboard />,
      },
      {
        path: 'sliders',
        element: <AdminSliders />,
      },
      {
        path: 'products',
        element: <AdminProducts />,
      },
      {
        path: 'contact',
        element: <AdminContact />,
      },
      {
        path: 'pages',
        element: <AdminPages />,
      },
      {
        path: 'banners',
        element: <AdminBannersPage />
      },
      {
        path: 'catalog',
        element: <AdminCatalogPage />,
      },
      {
        path: 'gallery',
        element: <AdminGalleryPage />,
      },
      {
        path: 'blog',
        element: <AdminBlogPage />,
      },
      {
        path: 'menu-settings',
        element: <AdminMenuSettingsPage />,
      },
      {
        path: 'logo-settings',
        element: <AdminLogoSettingsPage />,
      },
    ],
  },
  { path: '*', element: <NotFound /> }
];

export default routes;